export enum ApplicationStepperLabels {
  FIRST_INSURED = 'First insured',
  SECOND_INSURED = 'Second insured',
  SECOND_POLICY_HOLDER = 'Second policy holder',
  BENEFICIARIES = 'Beneficiaries',
  INSURANCE = 'Insurance',
  IDENTITY_VERIFICATION = 'IDENTITY_VERIFICATION',
  SUMMARY = 'Summary',
  FINAL = 'Final',
}
